import NewLayout from "@components/new-ui/Layout";
import React from "react";
import { CasestudyCard, CasestudyCardProps } from ".";
import { CaseStudyHerosection, CaseStudyInformation, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const casestudyCardsDetails: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/alrannan-administrative-services",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        sector: "Service",
        externalLink: "/case-study/dubai-housekeeping",
    },
];

const EdZeb: React.FC = () => {
    return (
        <NewLayout
            title="edZeb Technologies automates lead gen and comms with Gallabox | Case Study"
            description="See how edZeb Technologies improved client engagement, boosted lead generation by 30%, and scaled efficiently with Gallabox's automation features."
            canonical="https://gallabox.com/case-study/edzeb"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/edzeb/edzeb-og.png" }}
        >
            <CaseStudyHerosection
                title="How edZeb Technologies simplified lead engagement with Gallabox"
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/edzeb/edzeb-hero.png"}
                redirectUrl={"/case-study"}
            />
            <StatsInfo
                statsInfo={[
                    { percentage: "60%", label: "improvement in overall business growth" },
                    { percentage: "30%", label: "boost in lead generation" },
                    { percentage: "25%", label: "improvement in customer satisfaction" },
                ]}
            />

            <section className="max-w-7xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[{ label: "Category", value: ["Technology Services"] }]}
                            product={{
                                title: "Features Used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "WhatsApp Broadcast" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "WhatsApp Chatbot" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "WhatsApp Flows" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12 ">
                        <section id="About edZeb Technologies Pvt. Ltd.">
                            <p>
                                edZeb Technologies is a technology-driven solutions company delivering services across IT and automation. With a growing client base, edZeb wanted
                                to improve how they engaged and nurtured leads, while reducing their dependency on third-party apps.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation subTitle={"Challenges before Gallabox"} className="mt-0" />
                            <p className="mt-2">
                                edZeb faced one critical challenge, which was limitations in executing bulk messaging. The team struggled to send campaigns and updates at scale.
                                Relying on third-party apps made the process slow, disjointed, and inconsistent with their workflows.{" "}
                            </p>
                            <CaseStudyInformation subTitle={"Initial solutions tried"} className="mt-12" />
                            <p className="mt-2">Before Gallabox, edZeb used: </p>
                            <FeatureList
                                List={[
                                    {
                                        listItem: "Third-party bulk messaging apps that lacked reliability and integrations.",
                                    },
                                    {
                                        listItem: "Trial of other providers (WATI, AiSensy), but these failed to deliver the service consistency and support they needed.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation subTitle={"Why edZeb chose Gallabox"} className="mt-0" />
                            <p className="mt-2">Gallabox emerged as the right fit due to:</p>

                            <FeatureList
                                List={[
                                    {
                                        listItem: "Superior service quality, with responsive onboarding and support.",
                                    },
                                    {
                                        listItem: "Ease of use, allowing teams to adopt without steep learning curves.",
                                    },
                                    {
                                        listItem: "Automation-led features, including flows and chatbots, to streamline customer conversations.",
                                    },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                            <CaseStudyInformation subTitle={"Goals with Gallabox"} className="mt-10" />
                            <p className="mt-2">edZeb wanted Gallabox to help them:</p>
                            <FeatureList
                                List={[
                                    { listItem: "Generate and nurture more leads" },
                                    { listItem: "Streamline customer communication" },
                                    { listItem: "Retain customers through improved engagement" },
                                    { listItem: "Explore cross-sell and upsell opportunities" },
                                    { listItem: "Drive higher conversions" },
                                ]}
                                className="mt-4 bg-gray-100"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation subTitle={"Impact on business growth"} className="mt-0" />
                            <p className="mt-2">Post-implementation, edZeb achieved:</p>

                            <FeatureList
                                List={[
                                    {
                                        listItem: "30% boost in lead generation, driven by faster campaigns and outreach.",
                                    },
                                    {
                                        listItem: "25% increase in customer satisfaction, thanks to better response times.",
                                    },
                                    {
                                        listItem: "20% growth in employee productivity, as automation freed up time from repetitive tasks.",
                                    },
                                    {
                                        listItem: "60% overall positive impact on business growth, reinforcing Gallabox's role as a long-term partner.",
                                    },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <CaseStudyInformation subTitle={"Driving smarter communication at scale"} className="mt-10" />
                            <p className="mt-2">
                                With Gallabox, edZeb transformed its bulk messaging challenge into an opportunity for growth. The combination of automation, reliability, and strong
                                support has empowered the company to scale customer communication efficiently.
                            </p>
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <div className="max-w-6xl mx-auto">
                <section>
                    <h3 className="text-gray-900 mb-10 mt-5 text-left ml-4">Check out other customer stories</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCardsDetails?.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </section>
            </div>
        </NewLayout>
    );
};

export default EdZeb;
